// @ts-nocheck
import { _ } from "~/i18n";

export function getContextMenu(scope) {
	function ContextMenuItem(appOwner) {
		SMap.Control.ContextMenu.Item.call(this, "");
		this._isPoint = false;
		this._index = -1;
		this._appOwner = appOwner;
	}

	ContextMenuItem.prototype = Object.create({
		...SMap.Control.ContextMenu.Item.prototype,
	});

	ContextMenuItem.prototype.setData = function setData(isPoint, index) {
		this._isPoint = isPoint;
		this._index = index;
		// TODO ts-ignore
		this._dom.container.innerHTML = isPoint ? _("distanceMeter.contextMenuItem.marker") : _("distanceMeter.contextMenuItem.sector");
	};

	ContextMenuItem.prototype.click = function click(event, menu) {
		if (this._disabled) {
			return;
		}

		menu.close();
		this._appOwner.remove(this._index);
	};

	return new ContextMenuItem(scope);
}
